import { Address as MccsAddress } from '@/@types/generated'

const Address = ({ address }: Props) => (
  <div className="w-full gap-2">
    <div className="w-full">{address?.street1 ?? ''}</div>
    {address?.street2 && <div className="w-full">{address?.street2 ?? ''}</div>}
    <div className="flex w-full gap-2">
      <div>{address?.city ?? ''},</div>
      <div>{address?.stateProvince ?? ''}</div>
      <div className="flex">{address?.postalCode ?? ''}</div>
    </div>
  </div>
)

interface Props {
  address?: MccsAddress
}

export default Address
